import React, { useState } from "react";
import { Email, WhatsAppButtonAnalytics } from "../../../utils/Analytics";
import { isMobileDevice } from "../../../utils/DeviceDetector";
import { withTranslation } from 'react-i18next';

import './WishlistSharingButton.css';
//import { CallToOrderClicked } from "../../../utils/Analytics";
//import { callToOrderNumber } from "../../../utils/StaticAssetManager";

const WishlistSharingButton = ({ className, isCentered, sharingType, sharingIcon, sharingLink, openPopForm, t, onClick }) => {
    //const phoneNumber = callToOrderNumber;
    const phoneNumber = '74128..'
    //const [showNumber, setShowNumber] = useState(false);
    const isMobile = isMobileDevice();
    const href = isMobile ? `tel:${phoneNumber}` : 'javascript:void(0)';

    const onNumberClick = () => {
        if (!isMobile) {
            // if (!showNumber) {
            //     CallToOrderClicked();
            // }
            // setShowNumber(!showNumber);
        } else {
            //CallToOrderClicked();
        }
    }

    return <>
        {sharingType == t('wishlistCartDropdown4') ? 
            <a className={`call-to-order-btn-wrapper ${className} ${isCentered ? 'margin15-auto' : ''}`} style={{ margin: isCentered ? '' : '15px 15px 10px' }} onClick={() => openPopForm(sharingType)}>
                <span className="call-to-order-btn" >{sharingType}</span>
                <img src={sharingIcon} />
            </a> :
            <a onClick={onClick} className={`call-to-order-btn-wrapper ${className} ${isCentered ? 'margin15-auto' : ''}`} style={{ margin: isCentered ? '' : '15px 15px 10px' }} href={sharingLink} target="_blank">
                <span className="call-to-order-btn" >{sharingType}</span>
                <img src={sharingIcon} />
            </a>
        }
        
    </>
}

export default withTranslation()(WishlistSharingButton);